module.exports = __webpack_public_path__ + "3b5107925a4e445528ea9c5d8234a2ac.svg";